import(/* webpackMode: "eager" */ "/tmp/8de65d39bc7ade0/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65d39bc7ade0/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65d39bc7ade0/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65d39bc7ade0/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65d39bc7ade0/app/[locale]/integrations/[slug]/integration.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65d39bc7ade0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de65d39bc7ade0/node_modules/next/dist/client/link.js");
